'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenericSettingsSubHeader = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; // TODO: May EnterpriseError, EmailSettings and QuotesStorage should be containers.

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _modals = require('redux/modules/modals');

var _components = require('components');

var _GenericSettings = require('redux/modules/GenericSettings');

var _fetchStatusTypes = require('constants/fetchStatusTypes');

var STATUS = _interopRequireWildcard(_fetchStatusTypes);

var _GenericSettings2 = require('./GenericSettings.scss');

var _GenericSettings3 = _interopRequireDefault(_GenericSettings2);

var _GenericSettingsSubHeader2 = require('./GenericSettingsSubHeader');

var _GenericSettingsSubHeader3 = _interopRequireDefault(_GenericSettingsSubHeader2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GenericSettings = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GenericSettings, _Component);

  function GenericSettings() {
    (0, _classCallCheck3.default)(this, GenericSettings);
    return (0, _possibleConstructorReturn3.default)(this, (GenericSettings.__proto__ || (0, _getPrototypeOf2.default)(GenericSettings)).apply(this, arguments));
  }

  (0, _createClass3.default)(GenericSettings, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!__SERVER__ && this.props.genericSettingsStatus === STATUS.UNRETRIEVED) {
        this.props.getGenericSettings(this.props.codedToken);
        this.props.getStorageOptions(this.props.codedToken);
        this.props.getConfiguration(this.props.codedToken);
      }
    }
    /* Maybe here, it is not necessary to preload data on the server
     static preload = () => [
     [fetchGenericSettingsSaga, getGenericSettings.base()],
     [fetchStorageOptionsSaga, getStorageOptions.base()],
     ];
     */

  }, {
    key: '_renderSeparator',
    value: function _renderSeparator() {
      return _react2.default.createElement('div', { className: _GenericSettings3.default.defaultSeparator });
    }
  }, {
    key: '_renderContent',
    value: function _renderContent() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.QuotesStorage, null),
        this._renderSeparator(),
        _react2.default.createElement(_components.EmailSettings, null),
        this._renderSeparator(),
        _react2.default.createElement(_components.CannedRules, null)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          isLoading = _props.isLoading,
          error = _props.error;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(className, _GenericSettings3.default.root) },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Generic Settings' }),
        _react2.default.createElement(
          'div',
          { className: _GenericSettings3.default.container },
          !isLoading && !error && this._renderContent(),
          !isLoading && error && _react2.default.createElement(_components.EnterpriseError, { error: error })
        )
      );
    }
  }]);
  return GenericSettings;
}(_react.Component), _class.propTypes = {
  genericSettings: _react.PropTypes.object,
  storageOptions: _react.PropTypes.array,
  error: _react.PropTypes.object,
  isLoading: _react.PropTypes.bool,
  genericSettingsStatus: _react.PropTypes.string,
  getGenericSettings: _react.PropTypes.func,
  getStorageOptions: _react.PropTypes.func,
  changeProperty: _react.PropTypes.func,
  showModal: _react.PropTypes.func,
  hideModal: _react.PropTypes.func,
  className: _react.PropTypes.string,
  codedToken: _react.PropTypes.string
}, _temp);


var mapStateToProps = function mapStateToProps(state) {
  return {
    codedToken: state.auth.codedToken,
    genericSettings: state.genericSettings,
    error: state.genericSettings.error,
    isLoading: state.genericSettings.isLoading,
    genericSettingsStatus: state.genericSettings.status.genericSettingsStatus
  };
};

exports.GenericSettingsSubHeader = _GenericSettingsSubHeader3.default;
exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  getGenericSettings: _GenericSettings.getGenericSettings.base,
  getStorageOptions: _GenericSettings.getStorageOptions.base,
  getConfiguration: _GenericSettings.getConfiguration.base,

  changeProperty: _GenericSettings.changeProperty,
  showModal: _modals.show,
  hideModal: _modals.hide
})(GenericSettings);


//////////////////
// WEBPACK FOOTER
// ./src/containers/GenericSettings/GenericSettings.jsx
// module id = 1628
// module chunks = 0